import { render, staticRenderFns } from "./posNotes.vue?vue&type=template&id=19de813f"
import script from "./posNotes.vue?vue&type=script&lang=js"
export * from "./posNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports